
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 24 24","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"rgba(174, 180, 186, 1)","d":"M15.51 5.31v1.83c.19-.12.4-.21.64-.21.25 0 .46.09.66.21V5.31c0-.61-.21-1.17-.59-1.58-.29-.31-.66-.52-1.06-.59v1.14c0 .08-.02.15-.04.22.22.14.39.42.39.81z"}}),_c('path',{attrs:{"fill":"rgba(174, 180, 186, 1)","d":"M14.47 4.96h-1.35c-.38 0-.69-.31-.69-.69V3.1c0-.38.31-.69.69-.69h1.35c.38 0 .69.31.69.69v1.18c0 .38-.31.68-.69.68zM7.45 6.93c.25 0 .47.09.67.22V5.31c0-.4.18-.67.4-.81a.545.545 0 0 1-.05-.22V3.13c-.4.08-.77.28-1.06.6-.39.41-.6.97-.6 1.58v1.82c.19-.11.4-.2.64-.2z"}}),_c('path',{attrs:{"fill":"rgba(174, 180, 186, 1)","d":"M10.5 4.96H9.15c-.38 0-.69-.31-.69-.69V3.1c0-.38.31-.69.69-.69h1.35c.38 0 .69.31.69.69v1.18c0 .38-.31.68-.69.68zM12.88 13.74h-2.17c-2.49 0-4.52-2.03-4.52-4.52V8.18a1.24 1.24 0 1 1 2.48 0v1.05c0 1.12.91 2.03 2.03 2.03h2.17c1.12 0 2.03-.91 2.03-2.03V8.18a1.24 1.24 0 1 1 2.48 0v1.05c.02 2.49-2.01 4.51-4.5 4.51zM15.24 14.83h-1.69c-.58 0-1.06-.47-1.06-1.06v-.03H11v.03c0 1.41 1.15 2.56 2.56 2.56h1.69a1.06 1.06 0 0 1 0 2.12h-3.19c.07.23.12.46.12.71 0 .28-.06.54-.14.79h3.22c1.41 0 2.56-1.15 2.56-2.56s-1.17-2.56-2.58-2.56z"}}),_c('path',{attrs:{"fill":"rgba(174, 180, 186, 1)","d":"M9.73 16.72c-1.34 0-2.43 1.09-2.43 2.43s1.09 2.43 2.43 2.43 2.43-1.09 2.43-2.43a2.42 2.42 0 0 0-2.43-2.43z"}})])
          )
        }
      }
    